import wait from 'wait-promise';
import reportError from 'ha/helpers/bugsnag/reportError';
import {
  getIsMobile,
  getIsTablet,
  getCurrentScreenSize,
} from 'ha/modules/UI/selectors';
import getUtmSource from '../helpers/getUtmSource';
import getCampaignParams from '../helpers/getCampaignParams';
import identifyUser from './identifyUser';

const setupUTM = (mixpanel, location, referrer) => {
  const source = getUtmSource(location, referrer);

  mixpanel.register({ CurrentSource: source });
  mixpanel.register_once({ Source: source });
  mixpanel.people.set_once({ Source: source });
};

const setupCampaings = (mixpanel, location) => {
  // https://trello.com/c/ieIX3tTP/422-1-track-last-touch-attribution-via-utm-1
  // https://blog.mixpanel.com/2015/05/11/community-tip-last-touch-utm-tags/
  // Last Touch UTM Tags
  const campaignParams = getCampaignParams(location.query || {});

  mixpanel.people.set(campaignParams.params);
  mixpanel.people.set_once(campaignParams.firstParams);
  mixpanel.register(campaignParams.params);
};

const setupAjsDistinctId = (dispatch, mixpanel, config, setCookie) => {
  wait
    .before(60000)
    .until(() => mixpanel.__loaded) // eslint-disable-line no-underscore-dangle
    .then(() => {
      // Card #3094. A part of proof-of-concept. Must be generalized in case of validness.
      // Supplying registration events with Mixpanel's distinct_id.
      setCookie('ajs_distinct_id', mixpanel.get_distinct_id());
    })
    .catch(() => {
      if (config.debug) {
        reportError({
          name: 'Mixpanel',
          message: 'Loading failed by timeout',
        });
      }
    });
};

const setupGtag = config => {
  if (global.gtag && config.googleTrackingId) {
    global.gtag('config', config.googleTrackingId, {
      send_page_view: false,
    });
  }
};

const registerDevice = mixpanel => (_, getState) => {
  const state = getState();
  const isMobile = getIsMobile(state);
  const isTablet = getIsTablet(state);
  const screenSize = getCurrentScreenSize(state);

  mixpanel.register({
    isMobile,
    isTablet,
    isDesktop: !isMobile && !isTablet,
    screenSize,
  });
};

const initAnalytics = ({ config, location, referrer, setCookie }) => (
  dispatch,
  _,
  { segment },
) => {
  segment.onReady(mixpanel => {
    setupGtag(config);

    if (mixpanel) {
      setupUTM(mixpanel, location, referrer);
      setupCampaings(mixpanel, location);
      setupAjsDistinctId(dispatch, mixpanel, config, setCookie);
      dispatch(registerDevice(mixpanel));
    } else if (config.debug) {
      reportError({ name: 'Mixpanel', message: 'Is not defined' });
    }

    dispatch(identifyUser());
  });
};

export default initAnalytics;
